<template>
  <div class="vf-form-field" :data-field-type="field.dataType">
    <h3>{{ field.fieldName }}</h3>
    <div v-if="field.description" class="vf-form-field-description" v-html="textToHtml(field.description)"></div>
  </div>
</template>

<script>
  import { textToHtml } from '../../Forms/form-helper.js';
  export default {
    name: 'TitleDescriptionFieldRenderer',
    props: {
      field: {
        type: Object,
        required: true,
      },
    },

    methods: {
      textToHtml
    },
  };
</script>

<style scoped>

</style>
